import React from 'react';
import ContactInfo from './EmployeeProfileSections/personalInfoView';

export const PersonalInfo = ({record}) =>
  <div>
    <ContactInfo data={record} />
  </div>;

export default PersonalInfo;
